<app-loader></app-loader>

<!--section  -->
<section class="hero-section" data-scrollax-parent="true">
    <div class="bg-tabs-wrap">
        <div class="bg-parallax-wrap" data-scrollax="properties: { translateY: '200px' }">
            <!--ms-container-->
            <div class="slideshow-container" data-scrollax="properties: { translateY: '300px' }">
                <div class="swiper-container">
                    <div class="mySwiper_photo">
                        <div class="swiper-wrapper">
                            <!--ms_item-->
                            <div class="swiper-slide">
                                <div class="ms-item_fs fl-wrap full-height">
                                    <div class="bg" style="background-image: url('../assets/images/bg/2.jpg');"></div>
                                    <div class="overlay op7"></div>
                                </div>
                            </div>
                            <!--ms_item end-->
                            <!--ms_item-->
                            <div class="swiper-slide ">
                                <div class="ms-item_fs fl-wrap full-height">
                                    <div class="bg" style="background-image: url('../assets/images/bg/3.jpg');"></div>
                                    <div class="overlay op7"></div>
                                </div>
                            </div>
                            <!--ms_item end-->
                            <!--ms_item-->
                            <div class="swiper-slide">
                                <div class="ms-item_fs fl-wrap full-height">
                                    <div class="bg" style="background-image: url('../assets/images/bg/4.jpg');"></div>
                                    <div class="overlay op7"></div>
                                </div>
                            </div>
                            <!--ms_item end-->
                        </div>
                    </div>
                </div>
            </div>
            <!--ms-container end-->
        </div>
    </div>
    <div class="container small-container">
        <div class="intro-item fl-wrap">
            <span class="section-separator"></span>
            <div class="bubbles">
                <h1>Explore Best Business In City</h1>
            </div>
            <h3>Find some of the best tips from around the city from our partners and friends.</h3>
        </div>
        <div class="clarfix"></div>
        <!-- main-search-input-tabs-->
        <div class="main-search-input-tabs tabs-act fl-wrap">
            <div class="tabs-container fl-wrap">
                <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav nav-tabs w-100 mt-2">
                    
                    <li [ngbNavItem]="1">
                        <button ngbNavLink class="nav-link btn">Find Any</button>
                        <ng-template ngbNavContent>
                            <div class="main-search-input-wrap fl-wrap">
                                <div class="main-search-input fl-wrap">
                                    <form [formGroup]="findAny" (ngSubmit)="onSubmitFindAny()">
                                    <div class="main-search-input-item" style="width: 100%;">
                                        <label><i class="fal fa-handshake-alt"></i></label>
                                        <input type="text" placeholder="Find Any" [(ngModel)]="filterCriteria.name" formControlName="name"/>
                                    </div>
                                    <button type="submit" class="main-search-button btn btn-primary">Search <i class="far fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="2">
                        <button ngbNavLink class="nav-link btn">Find Business</button>
                        <ng-template ngbNavContent>
                            <div class="main-search-input-wrap fl-wrap">
                                <div class="main-search-input fl-wrap">
                                    <form [formGroup]="findBusiness" (ngSubmit)="onSubmitBusiness()">
                                        <div class="main-search-input-item">
                                            <label><i class="fal fa-keyboard"></i></label>
                                            <input type="text" [(ngModel)]="filterCriteria.name" formControlName="name" placeholder="What are you looking for?" value="" />
                                        </div>
                                        <div class="main-search-input-item location autocomplete-container">
                                            <label><i class="fal fa-map-marker-check"></i></label>
                                            <input type="text" [(ngModel)]="filterCriteria.location" formControlName="location" placeholder="Location"class="autocomplete-input" />
                                            <a href="#"><i class="fa fa-dot-circle-o"></i></a>
                                        </div>
                                        <div class="main-search-input-item">
                                            <label class="d-none"> <i class="fal fa-briefcase"></i></label>
                                            <div class="listsearch-input-item ">
                                                <select class="form-select" data-placeholder="All Categories"
                                                    formControlName="category" [(ngModel)]="filterCriteria.category">
                                                    <option [value]="null">-- Select Category --</option>
                                                    <option *ngFor="let category of categories" [value]="category.id">
                                                        {{ category.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <button type="submit" class="main-search-button btn btn-primary">Search <i class="far fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="3">
                        <button ngbNavLink class="nav-link btn">Find Product</button>
                        <ng-template ngbNavContent>
                            <div class="main-search-input-wrap fl-wrap">
                                <div class="main-search-input fl-wrap">
                                    <form [formGroup]="findProduct" (ngSubmit)="onSubmitProduct()">
                                        <div class="main-search-input-item">
                                            <label><i class="fal fa-handshake-alt"></i></label>
                                            <input type="text" [(ngModel)]="filterCriteria.name" formControlName="name" placeholder="Find Products" value="" />
                                        </div>
                                        <div class="main-search-input-item location autocomplete-container">
                                            <label><i class="fal fa-map-marker-check"></i></label>
                                            <input type="text" [(ngModel)]="filterCriteria.location" formControlName="location" placeholder="Location" class="autocomplete-input" value="" />
                                            <a href="#"><i class="fa fa-dot-circle-o"></i></a>
                                        </div>
                                        <div class="main-search-input-item">
                                            <label class="d-none"> <i class="fal fa-briefcase"></i></label>
                                            <div class="listsearch-input-item ">
                                                <select class="form-select" [(ngModel)]="filterCriteria.category" formControlName="category" data-placeholder="All Categories">
                                                    <option [value]="null">-- Select Category --</option>
                                                    <option *ngFor="let category of categories" [value]="category.id">
                                                        {{ category.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <button type="submit" class="main-search-button btn btn-primary">Search <i class="far fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                    <li [ngbNavItem]="4" class="d-none">
                        <button ngbNavLink class="nav-link btn">Find Premium Advertiser</button>
                        <ng-template ngbNavContent>
                            <div class="main-search-input-wrap fl-wrap">
                                <div class="main-search-input fl-wrap">
                                    <div class="main-search-input-item">
                                        <label><i class="fal fa-handshake-alt"></i></label>
                                        <input type="text" placeholder="Find Premium Advertiser" value="" />
                                    </div>
                                    <div class="main-search-input-item clact date-container">
                                        <span class="iconn-dec"><i class="fal fa-calendar"></i></span>
                                        <input type="date" placeholder="Today's Date and Time"
                                            name="datepicker-here-time" value="" />
                                        <span class="clear-singleinput"><i class="fal fa-times"></i></span>
                                    </div>
                                    <div class="main-search-input-item">
                                        <label> <i class="fal fa-briefcase"></i></label>
                                        <div class="listsearch-input-item ">
                                            <select class="form-select" data-placeholder="All Categories"
                                                formControlName="categoryInfoId">
                                                <option value="" selected>Select</option>
                                                <option *ngFor="let category of categories" [value]="category.id">
                                                    {{ category.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <button class="main-search-button btn btn-primary" routerLinkActive="active"
                                        routerLink="search">Search <i class="far fa-search"></i></button>
                                </div>
                            </div>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="nav" class="mt-2 d-block"></div>
            </div>
        </div>
        <div class="clarfix"></div>
        <!-- main-search-input-tabs end-->
        <div class="hero-categories fl-wrap">
            <h4 class="hero-categories_title">Just looking around ? Use quick search by category :</h4>
            <ul class="no-list-style">
                <li><a routerLinkActive="active" [routerLink]="['/business', getHyphenatedString('Medical & Health Product')]" title="Medical & Health"><i class="far fa-briefcase"></i><span>Medical & Health</span></a></li>
                <li><a routerLinkActive="active" [routerLink]="['/business', getHyphenatedString('Machinery & Industrial')]" title="Machinery & Industrial"><i class="fas fa-industry"></i><span>Machinery & Industrial</span></a></li>
                <li><a routerLinkActive="active" [routerLink]="['/business', getHyphenatedString('Home services')]" title="Home services"><i class="fas fa-house-damage"></i><span>Home services</span></a></li>
                <li><a routerLinkActive="active" [routerLink]="['/business', getHyphenatedString('Solar & Energy Product')]" title="Solar & Energy"><i class="fas fa-microchip"></i><span>Solar & Energy</span></a></li>
                <li><a routerLinkActive="active" [routerLink]="['/business', getHyphenatedString('Agriculture Services')]" title="Agriculture Services"><i class="fas fa-wheat"></i><span>Agriculture Services</span></a></li>
            </ul>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="#sec1" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--section end-->

<!-- Business section  -->
<section>
    <div class="container big-container">
        <div class="section-title">
            <h2><span>New Business Listings</span></h2>
            <div class="section-subtitle">Best Listings</div>
            <span class="section-separator"></span>
        </div>
        <div class="listing-filters gallery-filters fl-wrap hide">
            <a href="#" class="gallery-filter  gallery-filter-active" data-filter="*">All Categories</a>
            <a href="#" class="gallery-filter" data-filter=".restaurant">Restaurants </a>
            <a href="#" class="gallery-filter" data-filter=".hotels">Hotels</a>
            <a href="#" class="gallery-filter" data-filter=".events">Events</a>
            <a href="#" class="gallery-filter" data-filter=".fitness">Fitness</a>
        </div>
        <div class="grid-item-holder gallery-items fl-wrap">
            <!--  gallery-item-->
            <div class="gallery-item" *ngFor="let business of businessList;">
                <!-- listing-item  -->
                <div class="listing-item">
                    <app-business-card [businessData]="business"></app-business-card>
                </div>
                <!-- listing-item end -->
            </div>
            <!-- gallery-item  end-->
        </div>
        <a routerLinkActive="active" routerLink="/business" class="btn btn-primary">Check All Business Listings<i
                class="fal fa-arrow-alt-right"></i></a>
    </div>
</section>
<!--section end-->
<!--Ads section -->
<section class="gray-bg hidden-section particles-wrapper">
    <div class="container">
        <div class="section-title">
            <h2> Your Premium Advertiser</h2>
            <div class="section-subtitle">Business Advertising</div>
            <span class="section-separator"></span>
        </div>
        <div class="listing-item-grid_container fl-wrap">
            <div class="row">
                <!--  listing-item-grid  -->
                <div class="col-12 col-sm-6 col-md-4" *ngFor="let ads of businessAds;">
                    <div class="listing-item-grid">
                        <div class="bg" [ngStyle]="{'background-image': ' url('+serverImgUrl +'adsImages/'+ ads.adsImageURL+')'}"></div>
                        <div class="d-gr-sec"></div>
                        <div class="listing-counter color2-bg">
                            <span><i class="fas fa-map-marker-alt"></i> {{ads.businessCity}} | {{ads.adsDistrict}}, </span>{{ads.adsState}} | {{ads.adsCountry}}
                            <a href="{{ads.facebookURL}}" class="ms-1 text-white" target="_blank" title="Facebook"><i class="fab fa-facebook"></i></a>
                            <a href="{{ads.twitterURL}}" class="ms-1 text-white" target="_blank" title="Twitter"><i class="fab fa-twitter"></i></a>
                            <a href="{{ads.instagramURL}}" class="ms-1 text-white" target="_blank" title="Instagram"><i class="fab fa-instagram"></i></a>
                        </div>
                        <div class="listing-item-grid_title">
                            <h3><a routerLinkActive="active" [routerLink]="['/business-details', ads.businessName | businessSlug]" title="{{ads.adsTitle}}"> {{ads.adsTitle | shorten: 50: '...'}} </a></h3>
                            <p>{{ads.businessName | shorten: 30: '...'}}</p>
                            <p class="hide">{{ads.adsDetails | shorten: 100: '...'}}</p>
                        </div>
                    </div>
                </div>
                <!--  listing-item-grid end  -->
            </div>
        </div>
        <a routerLinkActive="active" routerLink="/business" class="btn btn-primary">View All Advertiser<i
                class="fal fa-arrow-alt-right"></i></a>
    </div>
</section>
<!--  section  -->
<!-- Product section  -->
<section class="slw-sec" id="sec1">
    <div class="section-title">
        <h2>Products Deals and Offers </h2>
        <div class="section-subtitle">Newest Products</div>
        <span class="section-separator"></span>
    </div>
    <div class="listing-slider-wrap fl-wrap">
        <div class="swiper mySwiper_product">
            <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let product of productList">
                    <app-product-card [productData]="product"></app-product-card>
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-scrollbar"></div>
            <div class="swiper-pagination w-100"></div>
        </div>
        <div class="text-center">
            <a routerLinkActive="active" routerLink="/products" class="btn-primary btn">View All Products<i class="fal fa-arrow-alt-right"></i></a> 
        </div>
    </div>
</section>
<!--section end-->
<div class="sec-circle fl-wrap"></div>

<!--section  -->
<section class="parallax-section" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/juby-ads.jpg');"
        data-scrollax="properties: { translateY: '30%' }"></div>
    <div class="overlay op7"></div>
    <!--container-->
    <div class="container">
        <div class="video_section-title fl-wrap">
            <h2> Are Buying New VMC/HMC? <br> contact us for attractive offers for tooling <br>
                <a href="https://businessinmaharashtra.com/business-details/juby-enterprises" target="_blank" class="btn-primary btn" title="Juby Enterprises">Visit <i class="fas fa-caret-right"></i></a>
            </h2>
        </div> 
    </div>
</section>
<!--section end-->

<!--section  -->
<section class="gray-bg">
    <div class="container">
        <div class="clients-carousel-wrap fl-wrap">
            <div class="cc-btn cc-prev"><i class="fal fa-angle-left"></i></div>
            <div class="cc-btn cc-next"><i class="fal fa-angle-right"></i></div>
            <div class="swiper-container">
                <div class="mySwiper_ads">
                    <div class="swiper-wrapper">
                        <!--client-item-->
                        <div class="swiper-slide">
                            <a routerLinkActive="active" href="https://businessinmaharashtra.com/business-details/dermacure" title="View Dermacure business profile" class="client-item"><img
                                    src="../../assets/images/clients/dermacure.jpg" alt="Dermacure" height="85"></a>
                        </div>
                        <!--client-item end-->
                        <!--client-item-->
                        <div class="swiper-slide">
                            <a routerLinkActive="active" href="https://businessinmaharashtra.com/business-details/juby-enterprises" title="View Juby Enterprises business profile" class="client-item"><img
                                    src="../../assets/images/clients/juby-enterprises-bhosari-pune-machine-tool-dealers.png" alt="Juby Enterprises " height="85"></a>
                        </div>
                        <!--client-item end-->
                         <!--client-item-->
                         <div class="swiper-slide">
                            <a routerLinkActive="active" href="https://businessinmaharashtra.com/business-details/mikro-ev" title="View Mikro EV business profile" class="client-item"><img src="../../assets/images/clients/mikro.PNG" alt="Mikro EV"></a>
                        </div>
                        <!--client-item end-->
                        <!--client-item-->
                        <div class="swiper-slide">
                            <a routerLinkActive="active" href="https://businessinmaharashtra.com/business-details/unified-markers-pvt-ltd" title="View Unified Markers business profile" class="client-item"><img
                                    src="../../assets/images/clients/unified-markers-pvt-ltd.PNG" alt="Unified Markers Pvt Ltd"></a>
                        </div>
                        <!--client-item end-->
                        <!--client-item-->
                        <div class="swiper-slide">
                            <a routerLinkActive="active" href="https://businessinmaharashtra.com/business-details/balaji-chair-and-decor" title="View Balaji Chair And Decor business profile" class="client-item"><img
                                    src="../../assets/images/clients/Balaji-Chair-And-Decor.PNG" alt="Balaji Chair And Decor"></a>
                        </div>
                        <!--client-item end-->
                        <!--client-item-->
                        <div class="swiper-slide">
                            <a routerLinkActive="active" href="https://businessinmaharashtra.com/business-details/js-motor" title="View JS Motor business profile" class="client-item"><img
                                    src="../../assets/images/clients/js-motor.PNG" alt="JS Motor"></a>
                        </div>
                        <!--client-item end-->
                        <!--client-item-->
                        <div class="swiper-slide">
                            <a routerLinkActive="active" routerLink="/business" title="Browse all business profiles" class="client-item"><img
                                    src="../../assets/images/clients/1.png" alt="Business in Maharashtra client logo" loading="lazy" decoding="async"></a>
                        </div>
                        <!--client-item end-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--section end-->
<!--section  -->
<section data-scrollax-parent="true">
    <div class="container">
        <div class="section-title">
            <h2>How it works</h2>
            <div class="section-subtitle">Discover &amp; Connect </div>
            <span class="section-separator"></span>
        </div>
        <div class="process-wrap fl-wrap">
            <ul class="no-list-style">
                <li>
                    <div class="process-item">
                        <span class="process-count">01 </span>
                        <div class="time-line-icon"><i class="fal fa-map-marker-alt"></i></div>
                        <h4> Find Interesting Place</h4>
                        <p> Acquire the most visible position in a category with a custom designed banner to reflect
                            your company and brand.
                        </p>
                    </div>
                    <span class="pr-dec"></span>
                </li>
                <li>
                    <div class="process-item">
                        <span class="process-count">02</span>
                        <div class="time-line-icon"><i class="fal fa-mail-bulk"></i></div>
                        <h4> Contact a Few Owners</h4>
                        <p>Direct owners contact with deal business inquiry with product selling, Multiple Product
                            uploding Facility.</p>
                    </div>
                    <span class="pr-dec"></span>
                </li>
                <li>
                    <div class="process-item">
                        <span class="process-count">03</span>
                        <div class="time-line-icon"><i class="fal fa-layer-plus"></i></div>
                        <h4> Make a Listing</h4>
                        <p> Customize users' experience, measure interest in our services, and inform users about
                            services and updates. </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</section>
<!--section end-->